export enum LoginAction { POSITIVE, NEGETIVE }



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/shared/login/loginAction.enum.ts